import { authService } from './AuthService';

/**
 * Add Authorization header with Bearer token to HTTP requests
 * Based on Angular AuthApiService.getAuthHeaders()
 * 
 * @param headers - Existing headers to merge with
 * @returns Headers with Authorization token if user is authenticated
 */
export async function addAuthHeader(headers: HeadersInit = {}): Promise<HeadersInit> {
  if (!authService.isAuthenticated) {
    return headers;
  }

  const token = await authService.getToken();
  if (!token) {
    return headers;
  }

  console.log('[Auth Interceptor] Adding Bearer token to request');
  
  return {
    ...headers,
    'Authorization': `Bearer ${token}`
  };
}

